export default __webpack_public_path__ + "static/media/residence-permit.74173868.svg";